import React from 'react'
import { useTranslation } from 'react-i18next'

import { NumbersOnlyInput } from 'aem-libs-react-ts/src/components/Inputs'
import { thousandsFormatter } from 'aem-libs-react-ts/src/utils/Formatters'

import ButtonLink from './ButtonLink'

import { RF_AMOUNT_INPUTS } from '../constants'

interface IProps {
  deposit: number
  userTracking: any
  minDeposit: number
  maxDeposit: number
  defaultDeposit: number
  onChange: (value: number) => void
  onHide: () => void
}

const ExtraDepositForm = ({
  deposit,
  onChange,
  onHide,
  userTracking,
  minDeposit,
  maxDeposit,
}: IProps) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='csas-calc-controls-label csas-calc-controls-label-fixed-medium'>
        {t('AMOUNT_INPUTS.EXTRA_DEPOSIT_LABEL')}
      </div>
      <div className='csas-calc-controls-group csas-mr-xs'>
        <div className='csas-calc-input csas-calc-input--extra-long'>
          <NumbersOnlyInput
            name='deposit'
            id='deposit'
            unit={t('CZK')}
            value={deposit}
            min={minDeposit}
            max={maxDeposit}
            format={thousandsFormatter}
            inputClass='csas-input-tel'
            onChangeComplete={onChange}
            userTracking={userTracking}
            rf={RF_AMOUNT_INPUTS.DEPOSIT_INPUT}
          />
        </div>
      </div>
      <ButtonLink
        rf={RF_AMOUNT_INPUTS.REMOVE_EXTRA_EXTRA_DEPOSIT}
        label={t('AMOUNT_INPUTS.REMOVE_EXTRA_DEPOSIT')}
        onClick={onHide}
      />
    </>
  )
}

export default ExtraDepositForm
